var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$$route$query;
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v(_vm._s((_vm$$route$query = _vm.$route.query) !== null && _vm$$route$query !== void 0 && _vm$$route$query.detail ? 'DETAIL' : _vm.isExistFleet ? 'UPDATE' : 'CREATE') + " SERVICE & REPAIR")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$fleetsOptions$fin, _vm$fleetsOptions$fin2, _vm$form$location, _vm$form$site, _vm$formatCurrency, _vm$formatCurrency2, _vm$form$remark, _vm$form$pic, _vm$form, _vm$form2, _vm$$route$query2, _vm$formErr;
        return [_c('div', {}, [_vm.$route.query.detail ? [_c('b-row', [_c('b-col', {
          attrs: {
            "lg": "6"
          }
        }, [_c('b-row', {
          staticClass: "align-items-center"
        }, [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Fleet")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(" " + _vm._s((_vm$fleetsOptions$fin = (_vm$fleetsOptions$fin2 = _vm.fleetsOptions.find(function (el) {
          return el.value == _vm.form.vehicle_id;
        })) === null || _vm$fleetsOptions$fin2 === void 0 ? void 0 : _vm$fleetsOptions$fin2.text) !== null && _vm$fleetsOptions$fin !== void 0 ? _vm$fleetsOptions$fin : '-'))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Location")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s((_vm$form$location = _vm.form.location) !== null && _vm$form$location !== void 0 ? _vm$form$location : '-'))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Site / Work Loacation")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s((_vm$form$site = _vm.form.site) !== null && _vm$form$site !== void 0 ? _vm$form$site : '-'))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Date Service & Repair")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s(_vm.formatDate(_vm.form.accident_at)))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Est. Start Date")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s(_vm.formatDate(_vm.form.start_date_est)))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Est. Finist Date")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s(_vm.formatDate(_vm.form.finish_date_est)))]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Est. Cost Service & Repair")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s((_vm$formatCurrency = _vm.formatCurrency(_vm.form.cost_est)) !== null && _vm$formatCurrency !== void 0 ? _vm$formatCurrency : '-'))]), _vm.form.finish_date_real ? [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Real Start Date")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s(_vm.formatDate(_vm.form.start_date_real)))])] : _vm._e(), _vm.form.start_date_real ? [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Real Finish Date")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s(_vm.formatDate(_vm.form.finish_date_real)))])] : _vm._e(), _vm.form.cost_real ? [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "5"
          }
        }, [_vm._v("Real Cost Service & Repair")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "7"
          }
        }, [_vm._v(_vm._s((_vm$formatCurrency2 = _vm.formatCurrency(_vm.form.cost_real)) !== null && _vm$formatCurrency2 !== void 0 ? _vm$formatCurrency2 : '-'))])] : _vm._e()], 2)], 1), _c('b-col', {
          attrs: {
            "lg": "6"
          }
        }, [_c('b-row', [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "12"
          }
        }, [_vm._v("Attachment Service & Repair")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', {
          staticClass: "m-0"
        }, _vm._l(_vm.form.filePreview, function (item, index) {
          return _c('b-col', {
            key: index,
            staticClass: "p-1 pr-2",
            attrs: {
              "md": "3"
            }
          }, [_c('AttachmentSR', {
            attrs: {
              "modelId": _vm.form.id,
              "modelName": "sr_form",
              "file": item
            },
            on: {
              "success-delete": _vm.deleteFile,
              "delete": function _delete() {
                return _vm.handleDeleteFile(item, index);
              }
            }
          })], 1);
        }), 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "12"
          }
        }, [_vm._v("Description")]), _c('b-col', {
          staticClass: "mb-3 text-black",
          attrs: {
            "md": "12"
          }
        }, [_vm._v(" " + _vm._s((_vm$form$remark = _vm.form.remark) !== null && _vm$form$remark !== void 0 ? _vm$form$remark : '-') + " ")]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "12"
          }
        }, [_vm._v("Vessel PIC")]), _c('b-col', {
          staticClass: "mb-3 text-black d-flex align-items-center",
          attrs: {
            "md": "12"
          }
        }, [_c('b-avatar', {
          attrs: {
            "variant": "warning"
          }
        }), _c('div', {
          staticClass: "ml-2"
        }, [_c('p', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s((_vm$form$pic = _vm.form.pic) !== null && _vm$form$pic !== void 0 ? _vm$form$pic : '-'))])])], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "12"
          }
        }, [_vm._v("Status")]), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "12"
          }
        }, [_vm.form.status ? _c('b-badge', {
          staticStyle: {
            "width": "max-content"
          },
          attrs: {
            "variant": "".concat(((_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : _vm$form.status) === 'new' ? 'info' : _vm.form.status === 'review' ? 'primary' : _vm.form.status === 'approved' ? 'success' : _vm.form.status === 'progress' ? 'warning' : 'danger', " d-block")
          }
        }, [_vm._v(_vm._s((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : _vm$form2.status))]) : _vm._e()], 1)], 1)], 1)], 1)] : _c('div', {
          staticClass: "border p-3 card-sr-information-form"
        }, [!((_vm$$route$query2 = _vm.$route.query) !== null && _vm$$route$query2 !== void 0 && _vm$$route$query2.finish) ? _c('b-row', [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "fleets"
          }
        }, [_vm._v("Fleet")]), _c('b-form-select', {
          attrs: {
            "plain": "",
            "name": "fleets",
            "id": "fleets",
            "options": _vm.fleetsOptions
          },
          model: {
            value: _vm.form.vehicle_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "vehicle_id", $$v);
            },
            expression: "form.vehicle_id"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "location"
          }
        }, [_vm._v("Accident Location")]), _c('b-input', {
          staticClass: "bg-white",
          attrs: {
            "id": "loaction"
          },
          model: {
            value: _vm.form.location,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "location", $$v);
            },
            expression: "form.location"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "date"
          }
        }, [_vm._v("Accident Date "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "id": "date"
          },
          model: {
            value: _vm.form.accident_at,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "accident_at", $$v);
            },
            expression: "form.accident_at"
          }
        }), (_vm$formErr = _vm.formErr) !== null && _vm$formErr !== void 0 && _vm$formErr.accident_at ? _c('small', {
          staticClass: "text-danger"
        }, [_vm._v("this field required")]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "work-location"
          }
        }, [_vm._v("Site / Work Location")]), _c('b-input', {
          staticClass: "bg-white w-100",
          attrs: {
            "id": "work-location"
          },
          model: {
            value: _vm.form.site,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "site", $$v);
            },
            expression: "form.site"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "pic"
          }
        }, [_vm._v("Fleet PIC")]), _c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "options": _vm.usersPic,
            "label": "label",
            "reduce": function reduce(opt) {
              return opt.id;
            }
          },
          on: {
            "input": function input(val) {
              return _vm.onInputPic(val, _vm.form);
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(_ref) {
              var userDetail = _ref.userDetail,
                email = _ref.email;
              return [_c('div', {
                staticClass: "d-flex justify-center"
              }, [_c('b-avatar', {
                staticClass: "mr-2",
                attrs: {
                  "src": userDetail === null || userDetail === void 0 ? void 0 : userDetail.photo,
                  "variant": "warning"
                }
              }), _c('div', [_c('p', {
                staticClass: "mb-0 black"
              }, [_vm._v(_vm._s(userDetail === null || userDetail === void 0 ? void 0 : userDetail.name))]), _c('small', {
                staticClass: "mb-0 black"
              }, [_vm._v(_vm._s(email))])])], 1)];
            }
          }, {
            key: "selected-option",
            fn: function fn(_ref2) {
              var userDetail = _ref2.userDetail;
              return [_c('div', {
                staticClass: "d-flex align-items-center"
              }, [_c('b-avatar', {
                staticClass: "mr-2",
                attrs: {
                  "src": userDetail === null || userDetail === void 0 ? void 0 : userDetail.photo,
                  "variant": "warning",
                  "size": "sm"
                }
              }), _c('p', {
                staticClass: "mb-0 black"
              }, [_vm._v(_vm._s(userDetail === null || userDetail === void 0 ? void 0 : userDetail.name))])], 1)];
            }
          }], null, false, 3319123226),
          model: {
            value: _vm.form.pic_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "pic_id", $$v);
            },
            expression: "form.pic_id"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "work-location"
          }
        }, [_vm._v("Est. Cost Service & Repair")]), _c('InputCurrency', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: _vm.form.cost_est,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "cost_est", $$v);
            },
            expression: "form.cost_est"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', [_vm._v("Est. Start Date")]), _c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "id": "date"
          },
          model: {
            value: _vm.form.start_date_est,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "start_date_est", $$v);
            },
            expression: "form.start_date_est"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', [_vm._v("Est. Finish Date")]), _c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "id": "date",
            "disabled-date": function disabledDate(date) {
              return _vm.disableEndDate(date, _vm.form.start_date_est);
            },
            "disabled": !_vm.form.start_date_est
          },
          model: {
            value: _vm.form.finish_date_est,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "finish_date_est", $$v);
            },
            expression: "form.finish_date_est"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "attachment"
          }
        }, [_vm._v("Attachment Service & Repairs")]), _c('InputFileMultiple', {
          attrs: {
            "labelKey": "input-file-sr-form",
            "files": _vm.form.filePreview
          },
          on: {
            "change-files": function changeFiles(val) {
              return _vm.handleInputFiles(val, _vm.form);
            }
          }
        }), _c('b-row', {
          staticClass: "m-0"
        }, _vm._l(_vm.form.filePreview, function (item, index) {
          return _c('b-col', {
            key: index,
            staticClass: "p-1 pr-2",
            attrs: {
              "lg": "6"
            }
          }, [_c('AttachmentSR', {
            attrs: {
              "modelId": _vm.form.id,
              "modelName": "sr_form",
              "file": item
            },
            on: {
              "success-delete": _vm.deleteFile,
              "delete": function _delete() {
                return _vm.handleDeleteFile(item, index);
              }
            }
          })], 1);
        }), 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('label', {
          attrs: {
            "for": "remark"
          }
        }, [_vm._v("Remarks")]), _c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "id": "remark",
            "placeholder": "input remarks...",
            "rows": "3"
          },
          model: {
            value: _vm.form.remark,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "remark", $$v);
            },
            expression: "form.remark"
          }
        })], 1)], 1) : _c('b-row', [_c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "date"
          }
        }, [_vm._v("Start Date Realization")]), _c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "id": "date"
          },
          model: {
            value: _vm.form.start_date_real,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "start_date_real", $$v);
            },
            expression: "form.start_date_real"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "date"
          }
        }, [_vm._v("Finish Date Realization")]), _c('date-picker', {
          staticClass: "w-100",
          attrs: {
            "id": "date",
            "disabled-date": function disabledDate(date) {
              return _vm.disableEndDate(date, _vm.form.start_date_real);
            },
            "disabled": !_vm.form.start_date_real
          },
          model: {
            value: _vm.form.finish_date_real,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "finish_date_real", $$v);
            },
            expression: "form.finish_date_real"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "work-location"
          }
        }, [_vm._v("Real Cost Service & Repair")]), _c('InputCurrency', {
          attrs: {
            "disabled": true
          },
          model: {
            value: _vm.form.cost_real,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "cost_real", $$v);
            },
            expression: "form.cost_real"
          }
        })], 1), _c('b-col', {
          staticClass: "mb-3",
          attrs: {
            "md": "3"
          }
        }, [_c('label', {
          attrs: {
            "for": "attachment"
          }
        }, [_vm._v("Attachment Service & Repairs")]), _c('InputFileMultiple', {
          attrs: {
            "label": "input-file-sr-form-finish",
            "files": _vm.form.filePreview
          },
          on: {
            "change-files": function changeFiles(val) {
              return _vm.handleInputFiles(val, _vm.form);
            }
          }
        }), _c('b-row', {
          staticClass: "m-0"
        }, _vm._l(_vm.form.filePreview, function (item, index) {
          return _c('b-col', {
            key: index,
            staticClass: "p-1 pr-2",
            attrs: {
              "lg": "6"
            }
          }, [_c('AttachmentSR', {
            attrs: {
              "modelId": _vm.form.id,
              "modelName": "sr_form",
              "file": item
            },
            on: {
              "success-delete": _vm.deleteFile,
              "delete": function _delete() {
                return _vm.handleDeleteFile(item, index);
              }
            }
          })], 1);
        }), 1)], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('label', {
          attrs: {
            "for": "remark-finish"
          }
        }, [_vm._v("Remarks Finish")]), _c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "id": "remark-finish",
            "placeholder": "input remarks finish...",
            "rows": "3"
          },
          model: {
            value: _vm.form.remark_finish,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "remark_finish", $$v);
            },
            expression: "form.remark_finish"
          }
        })], 1)], 1)], 1), _c('b-row', {
          staticClass: "mt-3"
        }, [_c('b-col', {
          staticClass: "my-3",
          attrs: {
            "md": "12"
          }
        }, [_c('ListItemSR', {
          attrs: {
            "headerForm": _vm.form,
            "headerFormErr": _vm.formErr,
            "fleetSelected": _vm.fleetSelected
          },
          on: {
            "existFleet": function existFleet($event) {
              _vm.isExistFleet = true;
            }
          }
        })], 1)], 1)], 2)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }